import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Signup({ setUser }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const navigate = useNavigate();  // Use navigate to programmatically navigate

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('/auth/signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await response.json();
      if (response.ok) {
        setUser({ username });  // Set the current user in the app state
        navigate('/challenges');  // Redirect to challenges page
      } else {
        setErrorMsg(data.message);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div className="bg-darkBackground flex flex-col justify-center items-center text-center" style={{ height: 'calc(100vh - 80px)' }}>
      <header className="text-center mb-4">
        <h1 className="text-6xl font-extrabold text-cyberBlue mb-6">
          Signup for MavHack
        </h1>
        <p className="text-lg text-gray-400 max-w-xl leading-relaxed">
          Create an account to get access to all challenges, track your progress, and compete with others.
        </p>
      </header>
      
      {errorMsg && <p className="text-red-500 mb-4">{errorMsg}</p>}

      <form onSubmit={handleSignup} className="bg-gray-800 p-6 rounded-lg shadow-lg max-w-lg w-full text-center">
        <input
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Username"
          required
          className="mb-4 w-full p-3 rounded-lg bg-gray-700 text-white"
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          required
          className="mb-4 w-full p-3 rounded-lg bg-gray-700 text-white"
        />
        <button
          type="submit"
          className="bg-accentBlue text-white py-4 px-8 rounded-full text-lg font-semibold shadow-lg hover:bg-cyberBlue transition-all duration-300 transform hover:-translate-y-1 focus:outline-none"
        >
          Signup
        </button>
      </form>
    </div>
  );
}

export default Signup;
